import { getFirestore, collection, getDocs, updateDoc, doc } from 'firebase/firestore';
import { app } from './firebase-config';
import { calculateAwardsForUser } from './awardRules';

const db = getFirestore(app);

export const recalculateUserPoints = async () => {
  try {
    // ✅ Fetch all users and events
    const usersSnapshot = await getDocs(collection(db, 'users'));
    const eventsSnapshot = await getDocs(collection(db, 'events'));

    const usersList = usersSnapshot.docs.map(d => ({ id: d.id, ...d.data() }));
    const eventsList = eventsSnapshot.docs.map(d => ({ id: d.id, ...d.data() }));

    // --- Step 1: Recalculate points and events for each user ---
    for (const user of usersList) {
      let newPoints = 0;
      let hostPoints = 0;
      let hostedEvents = [];
      let attendedEvents = [];

      for (const event of eventsList) {
        // ✅ Participation
        if (Array.isArray(event.Deltagelse) && event.Deltagelse.includes(user.name)) {
          attendedEvents.push(`${event.sted_konsept}, ${event.event_type}, ${event.Kvartal}`);

          switch (event.event_type) {
            case 'Blåtur🌍': newPoints += 7; break;
            case 'KD🧠': newPoints += 5; break;
            case 'KL🥩':
            case 'Vino🍷': newPoints += 4; break;
            default: break;
          }
        }

        // ✅ Hosting
        if (Array.isArray(event.Vert) && event.Vert.includes(user.name)) {
          hostedEvents.push(`${event.sted_konsept}, ${event.event_type}, ${event.Kvartal}`);
          switch (event.event_type) {
            case 'Vino🍷':
            case 'KL🥩': hostPoints += 4; break;
            case 'Blåtur🌍': hostPoints += 7; break;
            case 'KD🧠': hostPoints += 5; break;
            default: break;
          }
        }
      }

      // Save new host and participant points temporarily
      user.points = newPoints;
      user.host_points = hostPoints;
      user.hosted_events = hostedEvents;
      user.attended_events = attendedEvents;
    }

    // --- Step 2: Determine who gets 👑Beste arrangør👑 ---
    const topHostPoints = Math.max(...usersList.map(u => u.host_points || 0));
    const bestHosts = usersList.filter(u => (u.host_points || 0) === topHostPoints);

    // --- Step 3: Update Firestore with all new values ---
    for (const user of usersList) {
      // ✅ Recalculate individual awards
      const userWithEvents = { ...user, hosted_events: user.hosted_events };
      const awards = calculateAwardsForUser(userWithEvents, eventsList);
      const awardNames = awards.map(a => a.name);

      // ✅ Add Best Host award dynamically
      if (bestHosts.some(h => h.id === user.id)) {
        awardNames.push("Beste arrangør vandrepokal👑");
      }

      // ✅ Write back to Firestore
      const userRef = doc(db, 'users', user.id);
      await updateDoc(userRef, {
        points: user.points,
        host_points: user.host_points,
        hosted_events: user.hosted_events,
        attended_events: user.attended_events,
        awards: awardNames
      });
    }

    console.log('✅ User points, events, and awards (including Beste arrangør vandrepokal👑) updated successfully!');
  } catch (err) {
    console.error('🔥 Error recalculating user points:', err);
  }
};

